import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Alert,
  Snackbar
} from '@mui/material';
import { feedbackAPI } from '../../services/api';

const FeedbackDialog = ({ open, onClose }) => {
  const [type, setType] = useState('general_feedback');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const handleSubmit = async () => {
    if (!message.trim()) {
      setSnackbar({ open: true, message: 'Bitte gib eine Nachricht ein.', severity: 'warning' });
      return;
    }

    try {
      setLoading(true);
      await feedbackAPI.submitFeedback({ type, message });
      setSnackbar({ open: true, message: 'Feedback erfolgreich gesendet. Vielen Dank!', severity: 'success' });
      setMessage('');
      setTimeout(() => {
        onClose();
      }, 1500);
    } catch (error) {
      setSnackbar({ open: true, message: 'Fehler beim Senden des Feedbacks.', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>Feedback geben</DialogTitle>
        <DialogContent>
          <FormControl fullWidth margin="normal">
            <InputLabel>Art des Feedbacks</InputLabel>
            <Select
              value={type}
              onChange={(e) => setType(e.target.value)}
              label="Art des Feedbacks"
            >
              <MenuItem value="bug">Fehler melden (Bug)</MenuItem>
              <MenuItem value="feature_request">Verbesserungsvorschlag</MenuItem>
              <MenuItem value="general_feedback">Allgemeines Feedback</MenuItem>
            </Select>
          </FormControl>
          <TextField
            fullWidth
            label="Deine Nachricht"
            multiline
            rows={4}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            margin="normal"
            variant="outlined"
            placeholder="Was können wir besser machen?"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={loading}>Abbrechen</Button>
          <Button onClick={handleSubmit} variant="contained" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : 'Senden'}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default FeedbackDialog;
